import ResizableDrawer from './ResizableDrawer';

export default ResizableDrawer;
